/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import styles from "./Home.module.css";
import myImg from './Home profile img.jpeg'

export default function Home() {
  return (
    <>
      <div className="row w-100 m-auto my-4 py-5">
        <div className="col-md-6 mt-5 pt-2 d-flex justify-content-center">
          <div className="caption text-white">
            <h3 className={`${styles.helloWord}`}>Hey,</h3>
            <h1>
              I'm
              <span className={`${styles.myName} text-success fw-bolder`}> Muhammed Nabil</span>
            </h1>
            <p className={`${styles.paragraph} h4 `}>Front End web Developer</p>
            <p className='justify'>Experienced in working on Responsive web Apps using React, JS, TS, Redux, Sass, and
              Rest API's. Seeking a new challenge to improve technical and business skills.</p>
            <div className="my-contact ms-4">
              <div className="d-flex align-items-center mb-3">
                <i className="fa-solid fa-envelope fs-5 me-2"></i>
                <a className="text-center fs-6 mailto" href="mailto:mohammednabil1910@gmail.com">
                  mohammednabil1910@gmail.com
                </a>
              </div>
              <div className="d-flex align-items-center mb-3">
                <i className="fa-solid fa-location-dot fs-5 me-2"></i>
                <span className="text-center fs-6"
                >Hadayek El-Ahram, El-Haram, Giza</span
                >
              </div>
              <div className="d-flex align-items-center">
                <i className="fa-solid fa-phone fs-5 me-2"></i>
                <span className="text-center fs-6">01090594627</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 mt-4 d-flex justify-content-center">
          <img className='w-75 rounded-circle border border-5 border-success' src={myImg} alt="" />
        </div>
      </div>
    </>
  )
}
